import React from "react";
import moment from "moment";

export const NAME = "COMPANIES";

export const types = {
  COMPANIES_LIST_REQUEST: `${NAME}/COMPANIES_LIST_REQUEST`,
  COMPANIES_LIST_SUCCESS: `${NAME}/COMPANIES_LIST_SUCCESS`,
  COMPANIES_LIST_FAILURE: `${NAME}/COMPANIES_LIST_FAILURE`,
  GET_COMPANY_REQUEST: `${NAME}/GET_COMPANY_REQUEST`,
  GET_COMPANY_SUCCESS: `${NAME}/GET_COMPANY_SUCCESS`,
  GET_COMPANY_FAILURE: `${NAME}/GET_COMPANY_FAILURE`,

  DELETE_COMPANY_REQUEST: `${NAME}/DELETE_COMPANY_REQUEST`,
  DELETE_COMPANY_SUCCESS: `${NAME}/DELETE_COMPANY_SUCCESS`,
  DELETE_COMPANY_FAILURE: `${NAME}/DELETE_COMPANY_FAILURE`,

  COMPANY_CREATE_REQUEST: `${NAME}/COMPANY_CREATE_REQUEST`,
  COMPANY_CREATE_SUCCESS: `${NAME}/COMPANY_CREATE_SUCCESS`,
  COMPANY_CREATE_FAILURE: `${NAME}/COMPANY_CREATE_FAILURE`,
  COMPANY_EDIT_REQUEST: `${NAME}/COMPANY_EDIT_REQUEST`,
  COMPANY_EDIT_SUCCESS: `${NAME}/COMPANY_EDIT_SUCCESS`,
  COMPANY_EDIT_FAILURE: `${NAME}/COMPANY_EDIT_FAILURE`,
  EDIT_NOTIFICATION: `${NAME}/EDIT_NOTIFICATION`,
  CREATE_MEMO_ACTION: `${NAME}CREATE_MEMO_ACTION`,
  CREATE_PRODUCT_ACTION: `${NAME}CREATE_PRODUCT_ACTION`,
  EDIT_PRODUCT_ACTION: `${NAME}EDIT_PRODUCT_ACTION`,
  COMPANY_FORMS_RESET: `${NAME}/COMPANY_FORMS_RESET`,

  NOTIFICATION_CREATE_OR_UPDATE_REQUEST: `${NAME}/NOTIFICATION_CREATE_OR_UPDATE_REQUEST`,
  NOTIFICATION_CREATE_OR_UPDATE_SUCCESS: `${NAME}/NOTIFICATION_CREATE_OR_UPDATE_SUCCESS`,
  NOTIFICATION_CREATE_OR_UPDATE_FAILURE: `${NAME}/NOTIFICATION_CREATE_OR_UPDATE_FAILURE`,
  GET_NOTIFICATION_REQUEST: `${NAME}/GET_NOTIFICATION_REQUEST`,
  GET_NOTIFICATION_SUCCESS: `${NAME}/GET_NOTIFICATION_SUCCESS`,
  GET_NOTIFICATION_FAILURE: `${NAME}/GET_NOTIFICATION_FAILURE`,

  MARGE_PRODUCTS_REQUEST: `${NAME}/ MARGE_PRODUCTS_REQUEST`,
  MARGE_PRODUCTS_SUCCESS: `${NAME}/ MARGE_PRODUCTS_SUCCESS`,
  MARGE_PRODUCTS_FAILURE: `${NAME}/ MARGE_PRODUCTS_FAILURE`,

  NORIFICATION_MEMO_CREATE_REQUEST: `${NAME}/NORIFICATION_MEMO_CREATE_REQUEST`,
  NORIFICATION_MEMO_CREATE_SUCCESS: `${NAME}/NORIFICATION_MEMO_CREATE_SUCCESS`,
  NORIFICATION_MEMO_CREATE_FAILURE: `${NAME}/NORIFICATION_MEMO_CREATE_FAILURE`,
  GET_NORIFICATION_MEMO_REQUEST: `${NAME}/GET_NORIFICATION_MEMO_REQUEST`,
  GET_NORIFICATION_MEMO_SUCCESS: `${NAME}/GET_NORIFICATION_MEMO_SUCCESS`,
  GET_NORIFICATION_MEMO_FAILURE: `${NAME}/GET_NORIFICATION_MEMO_FAILURE`,

  RESET_PRODUCT_VALUES_REQUEST: `${NAME}/RESET_PRODUCT_VALUES_REQUEST`,
  RESET_PRODUCT_VALUES_SUCCESS: `${NAME}/RESET_PRODUCT_VALUES_SUCCESS`,
  RESET_PRODUCT_VALUES_FAILURE: `${NAME}/RESET_PRODUCT_VALUES_FAILURE`,

  SELECTED_COMPANY_SET: `${NAME}/SELECTED_COMPANY_SET`,
};

export const initialState = {
  selectedCompany: {
    city: undefined,
    director: undefined,
    generalArea: undefined,
    id: undefined,
    name: undefined,
    phoneNumber: undefined,
    region: undefined,
    state: undefined,
  },
  companiesList: {},
  notification: {
    period: 7,
    companyId: null,
    noticeOn: null,
    description: "",
    isProcesed: 0,
  },
  notificationMemo: [],
  lala: 2,
  showEditNotification: false,
  showCreateProduct: false,
  showCreateMemo: false,
  notificationMemoColumns: [
    {
      name: "id",
      options: {
        display: "executed",
        viewColumns: false,
        filter: false,
      },
    },
    {
      label: "Описание",
      name: "description",
    },
    {
      label: "Дата",
      name: "date",
      options: {
        filter: false,
        customBodyRender: (value) =>
          moment(value, "YYYY-MM-DD").format("DD.MM.yyyy"),
      },
    },
  ],
  tableColumns: [
    {
      name: "id",
      options: {
        display: "executed",
        viewColumns: false,
        filter: false,
      },
    },
    {
      name: "isProcesed",
      options: {
        display: "executed",
        viewColumns: false,
        filter: false,
      },
    },
    {
      label: "Название",
      name: "name",
      options: {
        filter: false,
      },
    },
    {
      label: "Общая площадь",
      name: "generalArea",
      options: {
        filter: false,
        customBodyRender: (value) => value + " Га",
      },
    },
    {
      label: "Область",
      name: "state",
    },
    {
      label: "Район",
      name: "region",
      options: {
        display: "executed",
      },
    },
    {
      label: "Населённый пункт",
      name: "city",
      options: {
        display: "executed",
      },
    },
    {
      label: "Директор",
      name: "director",
    },
    {
      label: "Телефон Директора",
      name: "phoneNumber",
    },
    {
      // Тип пишется полностью («Сельхозпроизводитель», «Завод», «Посредник»), без сокращений.
      label: "Тип компании",
      name: "type",
    },
    {
      label: "Остатки",
      name: "leftovers",
      options: {
        filter: true,
      },
    },
    {
      label: "Отмечен",
      name: "isProcesed",
      options: {
        display: "executed",
        customBodyRender: (value) => {
          return value ? "Да" : "Нет";
        },
      },
    },
  ],
  tableData: [],
  productTypes: [],
  // Список компаний ещё грузится (или не загрузился): экран показывает «Загрузка…» или
  // «Не удалось загрузить данные» с кнопкой «Повторить», а не таблицу с тестовыми данными.
  listLoading: true,
  listError: false,
  companyError: false,
  // Идёт очистка данных за сезон: кнопка в окне подтверждения заблокирована.
  isResetting: false,
};
export function reducer(state = initialState, action) {
  switch (action.type) {
    case types.MARGE_PRODUCTS_REQUEST:
      return { ...state, listLoading: true, listError: false };
    case types.MARGE_PRODUCTS_FAILURE:
      return { ...state, listLoading: false, listError: true };
    case types.GET_COMPANY_REQUEST:
      return { ...state, companyError: false };
    case types.COMPANIES_LIST_SUCCESS:
      return {
        ...state,
        tableData: action.payload,
      };
    case types.GET_COMPANY_SUCCESS:
      // A answer that could not be read comes as a SUCCESS with `error` and no data.
      if (action.error) return { ...state, companyError: true };
      return {
        ...state,
        selectedCompany: action.payload[0],
      };
    case types.GET_COMPANY_FAILURE:
      return {
        ...state,
        companyError: true,
        selectedCompany: initialState.selectedCompany, // Можно очистить состояние или оставить текущее
      };

    case types.DELETE_COMPANY_SUCCESS:
      if (action.payload) {
        return {
          ...state,
          notification: action.payload,
        };
      } else {
        return {
          ...state,
        };
      }
    case types.DELETE_COMPANY_FAILURE:
      return {
        ...state,
        selectedCompany: initialState.selectedCompany, // Можно очистить состояние или оставить текущее
        notification: action.payload,
      };

    case types.SELECTED_COMPANY_SET:
      return {
        ...state,
        selectedCompany: action.payload,
      };
    case types.COMPANY_CREATE_SUCCESS:
      return {
        ...state,
      };
    case types.COMPANY_EDIT_SUCCESS:
      return {
        ...state,
      };
    case types.GET_NOTIFICATION_SUCCESS:
      if (action.payload) {
        return {
          ...state,
          notification: action.payload,
        };
      } else {
        // У компании нет напоминания (сервер ответил пустым списком). Прежнее значение из store
        // нельзя оставлять: это либо заготовка по умолчанию, либо напоминание другой компании.
        return {
          ...state,
          notification: initialState.notification,
          needCreateMemo: true,
        };
      }
    case types.COMPANY_FORMS_RESET:
      // Страница компании открывается с обычными блоками, а не с формами, оставшимися открытыми
      // от прошлого визита.
      return {
        ...state,
        showEditNotification: false,
        showCreateMemo: false,
        showCreateProduct: false,
      };
    case types.EDIT_NOTIFICATION:
      return {
        ...state,
        showEditNotification: action.showEditNotification,
      };
    case types.CREATE_MEMO_ACTION:
      return {
        ...state,
        showCreateMemo: action.showCreateMemo,
      };
    case types.CREATE_PRODUCT_ACTION:
      return {
        ...state,
        showCreateProduct: action.showCreateProduct,
      };
    case types.EDIT_PRODUCT_ACTION:
      return {
        ...state,
        showCreateProduct: action.showCreateProduct,
      };
    case types.GET_NORIFICATION_MEMO_SUCCESS:
      return {
        ...state,
        notificationMemo: action.payload,
      };
    case types.RESET_PRODUCT_VALUES_REQUEST:
      return { ...state, isResetting: true };
    case types.RESET_PRODUCT_VALUES_SUCCESS:
    case types.RESET_PRODUCT_VALUES_FAILURE:
      return { ...state, isResetting: false };
    case types.MARGE_PRODUCTS_SUCCESS:
      if (action.error) return { ...state, listLoading: false, listError: true };
      return {
        ...state,
        listLoading: false,
        listError: false,
        tableData: action.payload.tableData,
        aditionalTableColumns: action.payload.aditionalTableColumns,
        productTypes: action.payload.productTypes
      };
    default:
      return { ...state };
  }
}
